import { render, staticRenderFns } from "./ExpensesEntryCrewDetails.vue?vue&type=template&id=975ec53e&scoped=true&"
import script from "./ExpensesEntryCrewDetails.vue?vue&type=script&lang=js&"
export * from "./ExpensesEntryCrewDetails.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesEntryCrewDetails.vue?vue&type=style&index=0&id=975ec53e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975ec53e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('975ec53e')) {
      api.createRecord('975ec53e', component.options)
    } else {
      api.reload('975ec53e', component.options)
    }
    module.hot.accept("./ExpensesEntryCrewDetails.vue?vue&type=template&id=975ec53e&scoped=true&", function () {
      api.rerender('975ec53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/entryForCrew/expenses/ExpensesEntryCrewDetails.vue"
export default component.exports